// extracted by mini-css-extract-plugin
module.exports = {"main":"Alert_main__2jXI6","close_wrapper":"Alert_close_wrapper__M2YTF"};